<template>
  <v-card align="center" justify="center" light min-width="27vw" max-width="37vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p style="color:#111111;">{{ $t('description') }}</p>
      <p style="background-color: #F1F1F1" class="py-5 mb-5">
        {{ event.name }} - {{ event.description }}<br>
        {{ $t('scheduledAt') }} {{ new Date(event.startDate).toISOString().substring(0, 10) }}
      </p>
      <v-btn @click="deleteEvent">{{ $t('btnDelete') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "DeleteEvent",
  props: {
    event: Object,
  },
  methods: {
    ...mapMutations(['setClubEvents']),
    deleteEvent() {
      Repository.deleteEvent(this.event.id).then((response) => {
        if(response.status < 400) {
          alert(this.$t('alert'));
          Repository.getAllClubEventsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.setClubEvents(secondResponse.data);
            this.close();
          });
        }
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Delete Event",
    "description": "Do you want to delete the event:",
    "scheduledAt": "Scheduled at",
    "alert": "Event was deleted successfully!",
    "btnDelete": "Yes, delete it now"
  },
  "es": {
    "title": "Eliminar Evento",
    "description": "Quieres eliminar el evento:",
    "scheduledAt": "Agendado para el",
    "alert": "¡Evento fue eliminado satisfactoriamente!",
    "btnDelete": "Sí, eliminar ahora"
  }
}
</i18n>

<style scoped>

</style>
